import React, { useState, useEffect } from "react";
import moment from "moment";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Box, Button, Divider, TextField, Tooltip } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import MuiAlert from "@mui/material/Alert";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ScheduleError from "./ScheduleError";
import ScheduleError1 from "./ScheduleError1";
// import ScheduleError_enddate from "./ScheduleError_enddate";
// import ScheduleError_enddatetime from "./ScheduleError_enddatetime";
// import ScheduleError_currentime from "./ScheduleError_currentime";
import CustomDaypicker from "./CustomDaypicker";
// import ScheduleError_doesnotmatch from "./ScheduleError_doesnotmatch";
import BudgetError from "./BudgetError";
import CircularProgress from '@mui/material/CircularProgress';
import { calculateScheduleFrequency } from '../../../utils/scheduleUtils';
// import Backdrop from '@mui/material/Backdrop';

const LoadingOverlay = ({ loading, children }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0)", // Semi-transparent white background
            backdropFilter: "blur(1px)", // Apply blur effect
            zIndex: 10, // Ensure loader is on top
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Box sx={{ opacity: loading ? 0.5 : 1, transition: "opacity 0.3s" }}>
        {children}
      </Box>
    </Box>
  );
};

function Alert(props) {
  return <MuiAlert elevation={6} {...props} />;
}

const Days = [
  { id: 0, name: "Sunday", value: "SUN" },
  { id: 1, name: "Monday", value: "MON" },
  { id: 2, name: "Tuesday", value: "TUE" },
  { id: 3, name: "Wednesday", value: "WED" },
  { id: 4, name: "Thursday", value: "THU" },
  { id: 5, name: "Friday", value: "FRI" },
  { id: 6, name: "Saturday", value: "SAT" },
];


export default function Schedule(props) {
  const { statevalue, onState, activeStep, handleBack, handleNext, classes } =
    props;

  const [loading, setLoading] = useState(false);

  const app = JSON.parse(statevalue);

  // Function to filter available days based on selected end_date_time
  const getAvailableDays = (startDate, endDate) => {
    if (!startDate || !endDate) return []; // Ensure both dates exist
  
    const start = new Date(startDate);
    const end = new Date(endDate);
  
    if (start > end) return []; // Invalid range
  
    const daySet = new Set();
  
    const current = new Date(start);
    while (current <= end) {
      daySet.add(current.getDay()); // Add day index (0 = Sunday, ..., 6 = Saturday)
      current.setDate(current.getDate() + 1); // Move to next day
    }
  
    // Assuming Days is an array like: [{ name: 'Sunday', id: 0 }, { name: 'Monday', id: 1 }, ...]
    return Days.filter((day) => daySet.has(day.id));
  };

  const [temporary, settemporary] = React.useState({
    repeat_frequency: "none",
  });
  const [schedulevalue, setSchedulevalue] = React.useState({
    repeat_frequency: "none",
    start_date_time: "",
    end_date_time: "",
    budgethours: 0,
    budgetStorageHours: 0
  });

  const [checkstate, setCheckstate] = React.useState({
    selectedValue: "checkedA",
  });
  

  const [total_hours, setTotalHours] = React.useState(0);
  const [scheduleError, setScheduleError] = React.useState("");

  const handleReload = () => {
    window.location.reload();
  };

  

  const [checkDeploystate, setCheckDeploystate] = React.useState({
    selectedDeployValue: "checkedA",
  });

  const [scheduleerroropen, setscheduleerroropen] = React.useState(false);
  const [scheduleerroropen1, setscheduleerroropen1] = React.useState(false);

  const [scheduleerroropen2, setscheduleerroropen2] = React.useState(false);
  const [scheduleerroropen3, setscheduleerroropen3] = React.useState(false);
  const [scheduleerroropen4, setscheduleerroropen4] = React.useState(false);
  const [scheduleerroropen5, setscheduleerroropen5] = React.useState(false);
  const [responseepochTime, setResponseEpochTime] = useState();
  // const [setMaxValue, setSetMaxValue] = React.useState(0);
  // const [setMinValue, setSetMinValue] = React.useState(0);
  const [calamount, setCalculateAmount] = React.useState(0);
  const [numberfind, setnumberfind] = useState(false);
  const MILLISECONDS_PER_HOUR = 1000 * 60 * 60;
  const MILLISECONDS_PER_MINUTE = 60 * 1000;
  const getFormattedCurrentDateTime = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60 * 1000);
    return localDate.toISOString().slice(0, 16);
  };

  const [budgetopen, setBudgetOpen] = React.useState(false);
  const [budgetValue, setBudgetValue] = React.useState('');
  const [error, setError] = useState(""); // Error message state
  const [showBudgetError, setShowBudgetError] = useState(false);

  useEffect(() => {
    setSchedulevalue((prevState) => ({
      ...prevState,
      repeat_frequency: "none",
      start_date_time: "",
      end_date_time: "",
      budgethours: 0,
      budgetStorageHours: 0
    }));
    setTotalHours(0);
    setBudgetValue('');
    setScheduleError("");
    setCheckDeploystate({ selectedDeployValue: "checkedA" });
  }, [checkstate]);

  // const [currentlocalTime, setCurrentLocalTime] = React.useState(new Date());

  const handlecheckChange = (event) => {
    setError("");
    const name = "selectedValue";
    setCheckstate({ [name]: event.target.value });

    if (checkstate.selectedValue !== "checkedB") {
      setSchedulevalue({
        repeat_frequency: "none",
      });
      settemporary({
        repeat_frequency: "none",
      })
    };

  };

  const handlecheckDeployChange = (event) => {
    const name = "selectedDeployValue";
    const id = "billingtype";
    setCheckDeploystate({ [name]: event.target.value });
    if (event.target.value === "checkedA") {
      onState((prevState) => ({
        ...prevState,
        [id]: "budgetbased",
      }));
      // setSchedulevalue({
      //   budgethours : 0,
      //   budgetStorageHours: 0
      // });
      schedulevalue.budgethours = 0;
     
    } else if (event.target.value === "checkedB") {
      onState((prevState) => ({
        ...prevState,
        [id]: "hourlybased",
      }));
      
      setBudgetValue('');
    }
  };

  // console.log("checkDeploystate", checkDeploystate);

  const [frequencyday, setFrequencyDay] = React.useState([]);
  const [frequencyMonth, setFrequencyMonth] = useState();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/getcurrentdatetime/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setResponseEpochTime(data);
        // console.log("test responseepochTime ---->", responseepochTime)
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);



  const handleBudgetChange = (e) => {
    const { id, value } = e.target;
    setnumberfind(false);

    const inputValue = e.target.value;
  
    // Ensure the value is a positive integer
    if (/^[0-9]*$/.test(inputValue)) {
      const numericValue = parseInt(inputValue, 10);
      if (numericValue <= 0) {
        setnumberfind(true);
      }else{
        onState((prevState) => ({
          ...prevState,
          [id]: value,
        }));
        settemporary((prevState) => ({
          ...prevState,
          [id]: value,
        }));
        setBudgetValue(value);
      }
    }
    else{
      // Input contains invalid characters (non-numeric)
      setnumberfind(true);
    }
  };


  const handleChange = (e) => {
    setError("");
    const { id, value } = e.target;
    const selectedDate = new Date(value);

    const currentDateTime = new Date();
    const epochTimeInGMT = (currentDateTime.getTime() + (currentDateTime.getTimezoneOffset() * 60 * 1000));
    const db_epochtime = responseepochTime * 1000;
    const timeDifference = Math.abs(epochTimeInGMT - db_epochtime);
    const final_time_difference = timeDifference / (60 * 1000)

    schedulevalue.budgethours = 0; // if change the time and date will defined as zero

    const serverEpochTimeMs = responseepochTime * 1000; 

    // console.log("Server Epoch Time (ms):", serverEpochTimeMs);
    // console.log("Selected Date (ms):", selectedDate);

    if (responseepochTime && selectedDate < serverEpochTimeMs) {
      setError("You cannot select a past date and time.");
      setSchedulevalue((prev) => ({
        ...prev,
        [id]: "", // Clear invalid date
      }));
      return;
    }
  
    // console.log("schedulevalue.start_date_time", schedulevalue.start_date_time);
    // console.log("schedulevalue.end_Date time", schedulevalue.end_date_time);

    if (id === "end_date_time") {
      const startDate = new Date(schedulevalue.start_date_time);
      const endDate = selectedDate;

      if (schedulevalue.start_date_time) {
        // Ensure End Date is not the same as Start Date
        if (startDate.getTime() === endDate.getTime()) {
          setError("You selected the same time for Start and End.");
        } else if (endDate < startDate) {
          setError("End Date & Time must be after Start Date & Time.");
        } else {
          setError("");
        }
      }
    }

    if (id === "start_date_time" || id === "end_date_time") {
      setTotalHours(0);
      const start = id === "start_date_time" ? value : (schedulevalue.start_date_time || getFormattedCurrentDateTime());
      // console.log("start", start);
      const end = id === "end_date_time" ? value : schedulevalue.end_date_time;
      // console.log("end", end);

      if (start && end) {
        const date1 = new Date(start);
        // console.log("date1", date1);
        const date2 = new Date(end);
        // console.log("date2", date2);
        const timeDiff = Math.abs(date2 - date1);
        // console.log("timeDiff", timeDiff);
        const diffHours = Math.round(timeDiff / MILLISECONDS_PER_HOUR);

        const diffMinutes = timeDiff / MILLISECONDS_PER_MINUTE;
        const roundedDiffMinutes = Math.round(diffMinutes);
        // const diffMinutes = diffHours * 60;

        // console.log("diffHours", diffHours);

        setTotalHours(diffHours);

        setSchedulevalue((prevState) => ({
          ...prevState,
          budgetStorageHours: roundedDiffMinutes,
        }));
        onState((prevState) => ({
          ...prevState,
          budgetStorageHours: roundedDiffMinutes,
        }));
      }
    }

    if (final_time_difference > 600) {
      setscheduleerroropen5(true)
    }
    else {

      if (checkstate.selectedValue !== "checkedB") {
        setSchedulevalue((prevState) => ({
          ...prevState,
          [id]: value,
          repeat_frequency: prevState.repeat_frequency !== undefined ? "none" : prevState.repeat_frequency,
        }));
      } else {
        setSchedulevalue((prevState) => ({
          ...prevState,
          [id]: value,
        }));
      }
      settemporary((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  

  // useEffect(() => {
  //   setSchedulevalue((prevState) => ({
  //     ...prevState,
  //     budgethours: 0,
  //   }));
  //   setBudgetValue('');
  //   setScheduleError("");

  // }, [checkDeploystate]);

  const handleChange1 = (event, value) => {
    const id = "cronvalue";
    setSchedulevalue((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };


  const handleHourlybasedChange = (e) => {
    const { id, value } = e.target;
    const hours = parseInt(value, 10);
    setnumberfind(false);

    const inputValue = e.target.value;
    if (/^[0-9]*$/.test(inputValue)) {
      const numericValue = parseInt(inputValue, 10);
      if (numericValue <= 0) {
        setnumberfind(true);
      }
      else{
        if (hours > total_hours) {
          setScheduleError("Please enter the appropriate hours");
        } else {
          setScheduleError("");
        }

        setSchedulevalue((prevState) => ({
          ...prevState,
          budgethours: value,
        }));

        onState((prevState) => ({
          ...prevState,
          [id]: value,
        }));
        settemporary((prevState) => ({
          ...prevState,
          [id]: value,
        }));
      }
    }
    else{
      // Input contains invalid characters (non-numeric)
      setnumberfind(true);
    }
  }

  const handleSubmitClick = async (e) => {
    setShowBudgetError(true);
    e.preventDefault();
    setLoading(true);
    let available = localStorage.getItem("available");
    setBudgetOpen(false);
    let budgetState = false;
    let hourlyBasedAmount = 0;
    let budget_hours = 0;


    if (checkDeploystate.selectedDeployValue !== "checkedB") {
      if (parseInt(budgetValue) > parseInt(available)) {
        setBudgetOpen(true);
        setLoading(false);
        budgetState = true;
      }
    } else {
      setBudgetOpen(false);
      budgetState = false;
    }

    if (checkDeploystate.selectedDeployValue === "checkedB") {
      var startDate;
      var endDate;
      budget_hours = schedulevalue.budgethours;

      if (schedulevalue.start_date_time) {
        startDate = new Date(schedulevalue.start_date_time);
          // .toISOString()
          // .split("T")[0];
      } else {
        startDate = new Date().toISOString();
      }

      if (schedulevalue.end_date_time) {
        endDate = new Date(schedulevalue.end_date_time);
          // .toISOString()
          // .split("T")[0];
      } else {
        endDate = new Date().toISOString().substring(0, 10);
      }

      

      var addvalue = app["customized_variable"];
      addvalue.labtype = "sharedvm";
      addvalue.nooftrainee = app["nooftrainee"];
      addvalue.machine_count = "0";
      addvalue.budgethours = schedulevalue.budgethours;
      addvalue.start_date = startDate;
      addvalue.end_date = endDate;

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/budgethourscalculation/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify(addvalue),
        });
        const data = await response.json();
        if (data) {
          setCalculateAmount(data);
          hourlyBasedAmount = data;
          onState((prevState) => ({
            ...prevState,
            hourlyBasedAmount: hourlyBasedAmount,
          }));
          // console.log(data);
          if (parseInt(hourlyBasedAmount) > parseInt(available)) {
            setBudgetOpen(true);
            setLoading(false);
            budgetState = true;
          } else {
            setBudgetOpen(false);
            budgetState = false;
          }
        } else {
          console.log("Error: No data received");
        }
      } catch (error) {
        console.error("Error fetching budget hours calculation:", error);
        // window.location.reload();
      }
    }

    if (!budgetState) {
      let timecount = 0;
      let timecount1 = 0;
      // let err_enddatebeforethedate = 0
      // let err_enddatebeforethedateandtime = 0
      let err_currenandlocaltime = 0

      var cron_expression_for_start;
      var cron_expression_for_end;
      var cron_expression_for_start2;
      var cron_expression_for_end2;
      var depends_on;

      var startDate;
      var endDate;
      // var NewstartDate;
      // var stDate1;

      var FinalstartTime;
      var FinalstopTime;
      var dummy_repeatFrequency;

      const repeatFrequency = schedulevalue.repeat_frequency;
      const Every = schedulevalue.every;

      if (schedulevalue.start_date_time) {
        startDate = new Date(schedulevalue.start_date_time).toISOString().split("T")[0];
        // Output: "2025-03-23"
        // console.log("startDate - 1", startDate);

      } else {
        startDate = new Date().toISOString().substring(0, 10);
        // console.log("startDate - 2", startDate);
      }

      if (schedulevalue.end_date_time) {
        endDate = new Date(schedulevalue.end_date_time).toISOString().split("T")[0];
        // console.log("endDate - 1", endDate);
        //endDate = new Date(schedulevalue.end_date_time + "Z").toISOString().split("T")[0];
      } else {
        endDate = new Date().toISOString().substring(0, 10);
        // console.log("endDate - 2", endDate);
      }
      

      // End Date and time cron for utc time 
      const utcEndDateTime = new Date(schedulevalue.end_date_time).toISOString();
      // Extract time part (HH:MM:SS)
      const timeEndPart = utcEndDateTime.split("T")[1].split(".")[0]; // "06:44:00"
      // Extract hours and minutes
      const utcEndDate = utcEndDateTime.split("T")[0];
      const [endyear, endmonths, enddays] = utcEndDate.split("-");
      const [stophours, stopminutes] = timeEndPart.split(":");

      FinalstopTime = `${stophours}:${stopminutes}`;

      if (checkstate.selectedValue !== "checkedC") {
        err_currenandlocaltime = 0
        if (err_currenandlocaltime === 0) {
          if (schedulevalue.cronvalue) {
            const onDays = schedulevalue.cronvalue;

            const MaponDays = onDays
              .sort((a, b) => (a.id > b.id ? 1 : -1))
              .map((ondayvalue) => {
                const one = ondayvalue.value;
                return one;
              });
            const stringonDays = JSON.stringify(MaponDays);
            const onDaysreplace = stringonDays
              .replace("[", "")
              .replace("]", "")
              .replace(/"/g, "");
            var NewonDays = onDaysreplace;
            var stronDays = NewonDays;
          }

          // Minutes Hours Days(start-end) Month(start-end) Week  Year(start-end)
          //    30     3        8-9              8-8         ?       2021-2021

          const utcDateTime = new Date(schedulevalue.start_date_time).toISOString();
          // Extract time part (HH:MM:SS)
          const timePart = utcDateTime.split("T")[1].split(".")[0]; // "06:44:00"
          // Extract hours and minutes
          const utcDate = utcDateTime.split("T")[0];
          const [year, startmonths, startdays] = utcDate.split("-");
          const [starthours, startminutes] = timePart.split(":");

          FinalstartTime = `${starthours}:${startminutes}`;

          if (checkstate.selectedValue === "checkedA") {
            depends_on = "always";
            cron_expression_for_start = `${startminutes} ${starthours} ${startdays} ${startmonths} ?`;
            cron_expression_for_end = `${stopminutes} ${stophours} ${enddays} ${endmonths} ?`;
            // console.log("cron_expression_for_start", cron_expression_for_start);
            // console.log("cron_expression_for_end", cron_expression_for_end);
            dummy_repeatFrequency = "none";
          }
          else if (checkstate.selectedValue === "checkedB") {
            depends_on = "during_training";
            dummy_repeatFrequency = repeatFrequency;
            if (repeatFrequency === "day") {
              if (frequencyday.length === 0) {
                timecount1 = timecount1 + 1;
              }
              else {
                // console.log("frequency -->", frequencyday[0])
                // cron_expression_for_start = `${startminutes} ${starthours} ${frequencyday[0]} ?`;
                // cron_expression_for_end = `${stopminutes} ${stophours} ${frequencyday[0]} ?`;

                let freq = 1;
                const updat_freq_start = calculateScheduleFrequency(schedulevalue.start_date_time, frequencyday, repeatFrequency, freq);
                const updat_freq_stop = calculateScheduleFrequency(schedulevalue.end_date_time, frequencyday, repeatFrequency, freq);
                cron_expression_for_start = `${startminutes} ${starthours} ${updat_freq_start} ?`;
                cron_expression_for_end = `${stopminutes} ${stophours} ${updat_freq_stop} ?`;
                
                // console.log("cron_expression_for_start", cron_expression_for_start);
                // console.log("cron_expression_for_end", cron_expression_for_end);
                if (frequencyday[1] !== undefined) {
                  freq = 2
                  const updat_freq_start2 = calculateScheduleFrequency(schedulevalue.start_date_time, frequencyday, repeatFrequency, freq);
                  const updat_freq_stop2 = calculateScheduleFrequency(schedulevalue.end_date_time, frequencyday, repeatFrequency, freq);
                  cron_expression_for_start2 = `${startminutes} ${starthours} ${updat_freq_start2} ?`;
                  cron_expression_for_end2 = `${stopminutes} ${stophours} ${updat_freq_stop2} ?`;
                  
                  // cron_expression_for_start2 = `${startminutes} ${starthours} ${frequencyday[1]} ?`;
                  // cron_expression_for_end2 = `${stopminutes} ${stophours} ${frequencyday[1]} ?`;
                } else {
                  cron_expression_for_start2 = 'multiple month not selected';
                  cron_expression_for_end2 = 'multiple month not selected';
                }
              }
            } else {
              if (stronDays === undefined) {
                timecount1 = timecount1 + 1;
              }
              else {
                cron_expression_for_start = `${startminutes} ${starthours} ? ${startmonths} ${NewonDays}`;
                cron_expression_for_end = `${stopminutes} ${stophours} ? ${startmonths} ${NewonDays}`;
                if (startmonths != endmonths) {
                  cron_expression_for_start2 = `${startminutes} ${starthours} ? ${endmonths} ${NewonDays}`;
                  cron_expression_for_end2 = `${stopminutes} ${stophours} ? ${endmonths} ${NewonDays}`;
                } else {
                  cron_expression_for_start2 = 'multiple month not selected';
                  cron_expression_for_end2 = 'multiple month not selected';
                }
              }
            }
          }

          // ******** Cron calculation is ending *****************
        }
        
      }
      if (checkstate.selectedValue === "checkedC") {
        depends_on = "immediate";
        dummy_repeatFrequency = "none";
        err_currenandlocaltime = 0

        const startDate_UTC = new Date().toISOString(); 
        const timePart = startDate_UTC.split("T")[1].split(".")[0];
        const [starthours, startminutes] = timePart.split(":");
        FinalstartTime = `${starthours}:${startminutes}`;

        if (err_currenandlocaltime === 0) {
          cron_expression_for_end = `${stopminutes} ${stophours} ${enddays} ${endmonths} ?`;
        }
      }

      // console.log("*******************Checking with log***********************************")
      // console.log("startDate", startDate)
      // console.log("endDate", endDate)
      // console.log("FinalstartTime", FinalstartTime)
      // console.log("FinalstopTime", FinalstopTime)
      // console.log("depends_on", depends_on)
      // console.log("repeatFrequency", dummy_repeatFrequency)
      // // console.log("Every", Every)
      // console.log("NewonDays", NewonDays)
      // console.log("cron_expression_for_start", cron_expression_for_start)
      // console.log("cron_expression_for_end", cron_expression_for_end)
      // console.log("cron_expression_for_start2", cron_expression_for_start2)
      // console.log("cron_expression_for_end2", cron_expression_for_end2)
      // console.log("budgethours", budget_hours)
      // console.log("hourlyBasedAmount", hourlyBasedAmount)

      if (timecount > 0) {
        setscheduleerroropen(true);
      }
      else if (timecount1 > 0) {
        setscheduleerroropen1(true);
      }
      // else if (err_enddatebeforethedate > 0) {
      //   console.log("error-2")
      //   setscheduleerroropen2(true);
      // }
      // else if (err_enddatebeforethedateandtime > 0) {
      //   console.log("error-3")
      //   setscheduleerroropen3(true);
      // }
      // else if (err_currenandlocaltime > 0) {
      //   console.log("error-4")
      //   setscheduleerroropen4(true);
      // } 
      else {
        //console.log("condition Satisfied");
        const id1 = "start_date";
        const id2 = "end_date";
        const id3 = "start_time";
        const id4 = "end_time";
        const id5 = "depends_on";
        const id6 = "repeat_frequency";
        const id7 = "every";
        const id8 = "on_days";
        const id9 = "startcron_expression";
        const id10 = "stopcron_expression";
        const id11 = "startcron_expression2";
        const id12 = "stopcron_expression2";
        const id13 = "budgethours";
        const id14 = "hourlyBasedAmount";
        onState((prevState) => ({
          ...prevState,
          [id1]: startDate,
          [id2]: endDate,
          [id3]: FinalstartTime,
          [id4]: FinalstopTime,
          [id5]: depends_on,
          [id6]: dummy_repeatFrequency,
          [id7]: Every,
          [id8]: NewonDays,
          [id9]: cron_expression_for_start,
          [id10]: cron_expression_for_end,
          [id11]: cron_expression_for_start2,
          [id12]: cron_expression_for_end2,
          [id13]: budget_hours,
          [id14]: hourlyBasedAmount,
        }));
        handleNext();
        setLoading(false);
      }
    
    }
  };

  var currentTime = new Date();
  var currentOffset = currentTime.getTimezoneOffset();
  var ISTOffset = 330; // IST offset UTC +5:30
  var ISTTime = new Date(
    currentTime.getTime() + (ISTOffset + currentOffset) * 60000
  );
  var hoursIST = ISTTime.getHours();
  var minutesIST = ISTTime.getMinutes();
  var currentDate = new Date().toISOString().substring(0, 10);
  let DateTimeformat = `${currentDate}`;
  let Dateformat = new Date(DateTimeformat);
  let currentDateTime = `${hoursIST}:${minutesIST}`;

  let localTime = new Date();
  let minDate1 = moment(localTime).format("YYYY-MM-DDTHH:MM");

  let startTimelocal = new Date(schedulevalue.start_date_time);
  let startday = (startTimelocal.getDate() + 1).toString().padStart(2, "0");
  let startmonth = (startTimelocal.getMonth() + 1).toString().padStart(2, "0");
  let startyear = startTimelocal.getFullYear();
  let maxDate1 = `${startyear}-${startmonth}-${startday}`;

  var nextMonth = ((Dateformat.getMonth() + 1) % 12) + 1;
  var cMonth = Dateformat.getMonth() + 1;

  if (cMonth === 12) {
    var year = currentTime.getFullYear() + 1;
    var date = new Date(`${year}`, `${nextMonth}`, 0);
    var endDate = date.getDate();
    var maxDate = `${year}-${nextMonth}-${endDate}`;
  } else {
    var year = currentTime.getFullYear();
    var date = new Date(`${year}`, `${nextMonth}`, 0);
    var endDate = date.getDate();
    var maxDate = `${year}-${nextMonth}-${endDate}`;
  }

  var maxDateFinal = new Date(maxDate).toISOString().substring(0, 10);

  const twoMonthsFromStartDate = (startDate) => {
    if (!startDate) {
      return "";
    }
    const date = new Date(startDate);
    date.setMonth(date.getMonth() + 2); // Adds two months to the date
  
    // Format the date to "YYYY-MM-DDTHH:mm" for the input's max attribute
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
  
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const twoMonthsFromCurrentDate = () => {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 2); // Adds two months to the current date
  
    // Format the date to "YYYY-MM-DDTHH:mm" for the input's max attribute
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  
  return (
    <React.Fragment>
      <LoadingOverlay loading={loading}>
        <Box sx={{ pt: 2 }}>
          <Typography variant="h6" gutterBottom>
            Scheduling
          </Typography>
        </Box>
        <BudgetError
          validerroropen={budgetopen}
          deployState={checkDeploystate.selectedDeployValue}
          setvaliderroropen={setBudgetOpen}
        />
        <ScheduleError
          validerroropen={scheduleerroropen}
          setvaliderroropen={setscheduleerroropen}
        />
        <ScheduleError1
          validerroropen={scheduleerroropen1}
          setvaliderroropen={setscheduleerroropen1}
        />
        {/* <ScheduleError_enddate
          validerroropen={scheduleerroropen2}
          setvaliderroropen={setscheduleerroropen2}
        />
        <ScheduleError_enddatetime
          validerroropen={scheduleerroropen3}
          setvaliderroropen={setscheduleerroropen3}
        />
        <ScheduleError_currentime
          validerroropen={scheduleerroropen4}
          setvaliderroropen={setscheduleerroropen4}
        />
        <ScheduleError_doesnotmatch
          validerroropen={scheduleerroropen5}
          setvaliderroropen={setscheduleerroropen5}
        /> */}
        <Box sx={{ height: 'auto', pt: 3 }}>
          <Box
            borderColor="error.main"
            border={checkstate.selectedValue === "checkedA" ? 1 : 0}
          >
            <Accordion square expanded={checkstate.selectedValue === "checkedA"}>
              <AccordionSummary>
                <FormControlLabel
                  aria-label="Acknowledge"
                  control={
                    <Checkbox
                      checked={checkstate.selectedValue === "checkedA"}
                      onChange={handlecheckChange}
                      value="checkedA"
                      color="secondary"
                    />
                  }
                  label={
                    <Typography variant="h5">
                      {" "}
                      Always{" "}
                      <small>
                        ( Lab will be running continuously between the schedule
                        provided )
                      </small>
                    </Typography>
                  }
                />
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={3}>
                  <Grid item md={3} xs={12}>
                    <Typography variant="h7" gutterBottom>
                      Start Date & Time
                    </Typography>
                    <TextField
                      fullWidth
                      name="start_date_time"
                      id="start_date_time"
                      type="datetime-local"
                      value={schedulevalue.start_date_time}
                      onChange={handleChange}
                      required
                      variant="outlined"
                      disabled={
                        checkstate.selectedValue === "checkedA"  ? false : true
                      }
                      inputProps={{
                        min: minDate1,
                        max: `${maxDateFinal}T00:00`,
                      }}
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item md={3} xs={12}>
                    <Typography variant="h7" gutterBottom>
                      End Date & Time
                    </Typography>
                    <TextField
                      fullWidth
                      name="end_date_time"
                      id="end_date_time"
                      type="datetime-local"
                      value={schedulevalue.end_date_time}
                      onChange={handleChange}
                      required
                      variant="outlined"
                      disabled={
                        checkstate.selectedValue === "checkedA" && 
                        !schedulevalue.start_date_time && 
                        !schedulevalue.end_date_time // Only disable if neither date is selected
                      }
                      inputProps={{
                        min: schedulevalue.start_date_time,
                        max: twoMonthsFromStartDate(schedulevalue.start_date_time),
                      }}
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                {error && (
                  <Alert severity="error" style={{ marginTop: "10px" }}>
                    {error}
                  </Alert>
                )}
              </AccordionDetails>
            </Accordion>
          </Box>
          <Box border={checkstate.selectedValue === "checkedB" ? 1 : 0}>
            <Accordion square expanded={checkstate.selectedValue === "checkedB"}>
              <AccordionSummary>
                <FormControlLabel
                  aria-label="Acknowledge"
                  control={
                    <Checkbox
                      checked={checkstate.selectedValue === "checkedB"}
                      onChange={handlecheckChange}
                      value="checkedB"
                      color="secondary"
                    />
                  }
                  label={
                    <Typography variant="h5">
                      {" "}
                      During Training Hours{" "}
                      <small>
                        ( Lab will be running at given frequencies between the
                        schedule provided )
                      </small>
                    </Typography>
                  }
                />
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={3}>
                  <Grid item md={3} xs={12}>
                    <Typography variant="h7" gutterBottom>
                      Start Date & Time
                    </Typography>
                    <TextField
                      fullWidth
                      name="start_date_time"
                      id="start_date_time"
                      type="datetime-local"
                      value={schedulevalue.start_date_time}
                      onChange={handleChange}
                      required
                      variant="outlined"
                      disabled={
                        checkstate.selectedValue === "checkedB" ? false : true
                      }
                      inputProps={{
                        min: minDate1,
                        max: `${maxDateFinal}T00:00`,
                      }}
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item md={3} xs={12}>
                    <Typography variant="h7" gutterBottom>
                      End Date & Time
                    </Typography>
                    <TextField
                      fullWidth
                      name="end_date_time"
                      id="end_date_time"
                      type="datetime-local"
                      value={schedulevalue.end_date_time}
                      onChange={handleChange}
                      required
                      variant="outlined"
                      disabled={
                        checkstate.selectedValue === "checkedB" && !schedulevalue.start_date_time // Disabled if no Start Date ? false : true
                      }
                      inputProps={{
                        min:
                          checkstate.selectedValue === "checkedB" &&
                            schedulevalue.start_date_time
                            ? schedulevalue.start_date_time
                            : minDate1,
                        max: twoMonthsFromStartDate(schedulevalue.start_date_time),
                      }}
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                {error && (
                  <Alert severity="error" style={{ marginTop: "10px" }}>
                    {error}
                  </Alert>
                )}
                <Box sx={{ pb: 2, pt: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Frequency Details
                  </Typography>
                  <Divider />
                </Box>
                <Grid container spacing={3}>
                  <Grid item md={4} xs={4}>
                    <Typography variant="h8" gutterBottom>
                      Repeat Frequency
                    </Typography>
                    <TextField
                      fullWidth
                      name="repeat_frequency"
                      id="repeat_frequency"
                      value={schedulevalue.repeat_frequency}
                      onChange={handleChange}
                      disabled={
                        checkstate.selectedValue === "checkedB" ? false : true
                      }
                      required
                      select
                      SelectProps={{ native: true }}
                      autoComplete="repeat_frequency"
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                    >
                      {" "}
                      <option key="" value=""></option>
                      <option key="day" value="day">
                        Specific Day's
                      </option>
                      <option key="week" value="week">
                        Weekly
                      </option>
                    </TextField>
                  </Grid>
                  {checkstate.selectedValue === "checkedB" && temporary.repeat_frequency === "day" && schedulevalue.end_date_time ? (
                    <Grid item md={4} xs={4}>
                      <Typography variant="h8" gutterBottom>
                        Choose the Required Dates
                      </Typography>
                      <CustomDaypicker
                        setFrequencyDay={setFrequencyDay}
                        setFrequencyMonth={setFrequencyMonth}
                        startDate={new Date(schedulevalue.start_date_time).toISOString()}
                        endDate={new Date(schedulevalue.end_date_time).toISOString()}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                  {temporary.repeat_frequency === "week" && schedulevalue.end_date_time && !isNaN(new Date(schedulevalue.end_date_time).getTime()) ? (
                    <Grid item md={4} xs={4}>
                      <Typography variant="h8" gutterBottom>
                        On Days
                      </Typography>
                      <Autocomplete
                        multiple
                        name="on_days"
                        size="small"
                        limitTags={2}
                        options={getAvailableDays(schedulevalue.start_date_time, schedulevalue.end_date_time)}
                        onChange={handleChange1}
                        disabled={
                          checkstate.selectedValue === "checkedB" ? false : true
                        }
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                          <React.Fragment>
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="On Days"
                            />
                          </React.Fragment>
                        )}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Box>
          <Box
            borderColor="error.main"
            border={checkstate.selectedValue === "checkedC" ? 1 : 0}
          >
            <Accordion square expanded={checkstate.selectedValue === "checkedC"}>
              <AccordionSummary>
                <FormControlLabel
                  aria-label="Acknowledge"
                  control={
                    <Checkbox
                      checked={checkstate.selectedValue === "checkedC"}
                      onChange={handlecheckChange}
                      value="checkedC"
                      color="secondary"
                    />
                  }
                  label={
                    <Typography variant="h5">
                      {" "}
                      Immediate{" "}
                      <small>( Lab will be running upto end date )</small>
                    </Typography>
                  }
                />
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={3}>
                  <Grid item md={3} xs={12}>
                    <Typography variant="h7" gutterBottom>
                      End Date & Time
                    </Typography>
                    <TextField
                      fullWidth
                      name="end_date_time"
                      id="end_date_time"
                      type="datetime-local"
                      value={schedulevalue.end_date_time}
                      onChange={handleChange}
                      required
                      variant="outlined"
                      disabled={
                        checkstate.selectedValue === "checkedC" ? false : true
                      }
                      inputProps={{
                        min: minDate1,
                        max: twoMonthsFromCurrentDate(),
                      }}
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                {error && (
                  <Alert severity="error" style={{ marginTop: "10px" }}>
                    {error}
                  </Alert>
                )}
              </AccordionDetails>
            </Accordion>
          </Box>
          <Box sx={{ pt: 2 }}>
            <Typography variant="h6" gutterBottom>
              Billing Type
            </Typography>
          </Box>
          <Box
            borderColor="error.main"
            border={checkDeploystate.selectedDeployValue === "checkedA" ? 1 : 0}
          >
            <Accordion square expanded={checkDeploystate.selectedDeployValue === "checkedA"}>
              <AccordionSummary>
                <FormControlLabel
                  aria-label="Acknowledge"
                  control={
                    <Checkbox
                      checked={checkDeploystate.selectedDeployValue === "checkedA"}
                      onChange={handlecheckDeployChange}
                      value="checkedA"
                      color="secondary"
                    />
                  }
                  label={
                    <Typography variant="h5">
                      {" "}
                      Budget Based{" "}
                    </Typography>
                  }
                />
              </AccordionSummary>
            </Accordion>
          </Box>
          <Box
            borderColor="error.main"
            border={checkDeploystate.selectedDeployValue === "checkedB" ? 1 : 0}
          >
            <Accordion square expanded={checkDeploystate.selectedDeployValue === "checkedB"}>
              <AccordionSummary>
                <FormControlLabel
                  aria-label="Acknowledge"
                  control={
                    <Checkbox
                      checked={checkDeploystate.selectedDeployValue === "checkedB"}
                      onChange={handlecheckDeployChange}
                      value="checkedB"
                      color="secondary"
                    />
                  }
                  label={
                    <Typography variant="h5">
                      {" "}
                      Hourly Based{" "}
                    </Typography>
                  }
                />
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={3}>
                  <Grid item md={3} xs={12}>
                    <Typography variant="h7" gutterBottom>
                      Hours<small style={{ paddingLeft: "10px" }}>required</small>
                      <small style={{ color: "red" }}>*</small>
                    </Typography>
                    <TextField
                      fullWidth
                      name="budgethours"
                      id="budgethours"
                      // disabled={schedulevalue.start_date_time && schedulevalue.end_date_time ? false : true}
                      onChange={handleHourlybasedChange}
                      onKeyPress={(e) => {
                        const charCode = e.which ? e.which : e.keyCode;
                        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                          e.preventDefault();
                        }
                      }}
                      required
                      type="number"
                      autoComplete="budgethours"
                      value={schedulevalue.budgethours}
                      // disabled={checkDeploystate.selectedDeployValue === "checkedB" ? false : true}
                      inputProps={{
                        min: 0,
                        max: total_hours,
                        step: "1",
                      }}
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                      error={!!scheduleError}
                      helperText={scheduleError}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h8">
                    <strong>Note:</strong>
                    <small>
                      {" "}
                      Please select the Start time and Stop time which includes the idle hours.
                    </small>
                  </Typography>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Box>
          {checkDeploystate.selectedDeployValue !== "checkedB" && (
            <>
              <Divider style={{ marginBottom: "20px" }} />
              <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
                <Box sx={{ pb: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    {" "}
                    Budget  *{" "}
                  </Typography>
                </Box>
                <Grid item xs={12} style={{ marginTop: "-20px" }}>
                  <Typography variant="h8">
                    Provide the credit budget for your lab. Once your budget is exhausted, your lab will be automatically Cordened and Terminated next day.
                  </Typography>
                  <Grid item md={3} xs={12}>
                  <TextField
                      fullWidth
                      sx={{ maxWidth: 260 }}
                      helperText={showBudgetError && !budgetValue ? 'Budget is required' : 'Note: Enter your Budget in Credits'}
                      size="small"
                      name="budget"
                      id="budget"
                      onChange={handleBudgetChange}
                      required
                      type="number"
                      variant="outlined"
                      error={showBudgetError && !budgetValue}
                      inputProps={{ min: "1", step: "1" }}
                      InputProps={{
                        style: {
                          height: "36px",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              pt: 2,
            }}
          >
            <div>
              <Tooltip title="Cancel and reset this step">
                <span>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleReload}
                    className={classes}
                    sx={{ borderRadius: '50px' }}
                  >
                    Cancel
                  </Button>
                </span>
              </Tooltip>
            </div>
            <div className={classes}>
              {activeStep !== 0 && (
                <Tooltip title="Go back to previous step">
                  <span>
                    <Button onClick={handleBack} variant="contained" className={classes} sx={{ borderRadius: '50px', mr: 0.5 }}>
                      Back
                    </Button>
                  </span>
                </Tooltip>
              )}
              <Tooltip title={
                !(
                  (checkstate.selectedValue === "checkedA" &&
                    schedulevalue.start_date_time &&
                    schedulevalue.end_date_time) ||
                  (checkstate.selectedValue === "checkedB" &&
                    schedulevalue.start_date_time &&
                    schedulevalue.end_date_time &&
                    (schedulevalue.repeat_frequency || schedulevalue.on_days)) ||
                  (checkstate.selectedValue === "checkedC" &&
                    !numberfind &&
                    schedulevalue.end_date_time)
                ) ||
                !(
                  (checkDeploystate.selectedDeployValue === "checkedA" && budgetValue) ||
                  (checkDeploystate.selectedDeployValue === "checkedB" &&
                    schedulevalue.budgethours)
                ) ||
                scheduleError
                  ? "Please fill in all required fields"
                  : "Proceed to the next step"
              }>
                <span>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmitClick}
                    className={classes}
                    disabled={
                      !(
                        (checkstate.selectedValue === "checkedA" &&
                          schedulevalue.start_date_time &&
                          schedulevalue.end_date_time) ||
                        (checkstate.selectedValue === "checkedB" &&
                          schedulevalue.start_date_time &&
                          schedulevalue.end_date_time &&
                          (schedulevalue.repeat_frequency || schedulevalue.on_days)) ||
                        (checkstate.selectedValue === "checkedC" &&
                          !numberfind &&
                          schedulevalue.end_date_time)
                      ) ||
                      !(
                        (checkDeploystate.selectedDeployValue === "checkedA" && budgetValue) ||
                        (checkDeploystate.selectedDeployValue === "checkedB" &&
                          schedulevalue.budgethours)
                      ) ||
                      scheduleError
                    }
                    sx={{ borderRadius: '50px' }}
                  >
                    Next
                  </Button>
                </span>
              </Tooltip>
            </div>
          </Box>
        </Box>
      </LoadingOverlay>
    </React.Fragment>
  );

}
